import { routeBuilder } from '@is24at/react-utils';
import { Local } from '@is24at/react-constants';

export const URLs = {
  ...Local,
  ROOT: routeBuilder.withMountRoot('/'),
  GRAPHQL_URL: routeBuilder.withMountRoot(Local.GRAPHQL_URI),
  NOT_FOUND: routeBuilder.withMountRoot('*'),
};
